import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import MUITextField from '@mui/material/TextField';
import { checkVat } from '../../lib/helpers';

export type VATFieldProps = {
    name: string;
    label: string;
    required?: boolean;
    selectedCountry?: string | number;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
};

const VATField = ({ name, label, required, selectedCountry, onChange, ...rest }: VATFieldProps) => {
    const { values, setFieldValue } = useFormikContext<any>();

    const VATFieldChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setFieldValue(name, e.currentTarget.value);
        onChange?.(e);
    };

    useEffect(() => {
        if (values[name] !== '' && (selectedCountry === 197 || selectedCountry === '197') && !checkVat(values[name])) {
            setFieldValue('VATFormatError', true);
        } else {
            setFieldValue('VATFormatError', false);
        }
    }, [selectedCountry, values[name]]);

    return <MUITextField required={required} name={name} label={label} onChange={VATFieldChangeHandler} {...rest} />;
};

export default VATField;
